import * as types from "@/redux/types";

const initialState = { isOfflineViewVisible: false };

export const offlineReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case types.HIDE_OFFLINE_VIEW: return { isOfflineViewVisible: false };

        case types.SHOW_OFFLINE_VIEW: return { isOfflineViewVisible: true };

        default: return state;
    }
};
